import { AutomationUserOverview } from "../../../../domain/automation-user";
import { OrganizationDetails } from "../../../../domain/organization";
import { UserDetails } from "../../../../domain/user";

export enum EditAutomationDialogMode {
  Create = "create",
  Edit = "edit",
}

export interface EditAutomationUserDialogConfig {
  /**
   * The user who opened the dialog.
   */
  openingUser: UserDetails;
  /**
   * Whether to open the dialog in create mode, or edit mode.
   * Edit mode will attempt to update an existing user, create mode will
   * attempt to create a brand new one.
   */
  dialogMode: EditAutomationDialogMode;
  /**
   * The organization this AutomationUser is being created/edited under.
   */
  organization: OrganizationDetails;
  /**
   * The Automation User whose information will be displayed, or `null`, if creating a new one.
   */
  automationUser: AutomationUserOverview | null;
}
